import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css'
import SlickSlider, { Settings } from 'react-slick';

export interface SliderProps {
  settings: Settings;
  children: React.ReactNode;
}

export interface SliderCommands {
  next: () => void;
  previous: () => void;
  goTo: (slideNumber: number) => void;
}

/**
 * Wrapper for react-slick
 */
const Slider = React.forwardRef((props: SliderProps, ref) => {
  const [slider, setSlider] = React.useState<SlickSlider | null>();
  React.useImperativeHandle(ref, () => ({
    next() {
      slider?.slickNext();
    },
    previous() {
      slider?.slickPrev();
    },
    goTo(slideNumber: number) {
      slider?.slickGoTo(slideNumber)
    }
  }));

  return (
    <SlickSlider ref={c => (setSlider(c))}  {...props.settings}>
      {props.children}
    </SlickSlider>
  )
});

export default Slider;
